import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Paper,
  Tooltip,
  Alert,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CabecalhoTabela from "./TableHeader.component";
import LinhasTabela from "./TableRowsComponent";
import { produtosMock } from "./NewPurchaseOrder.component";

const TabelaPedido = ({ itensProps = [], onValoresAtualizados }) => {
  const [itens, setItens] = useState([
    {
      id: 1,
      produto: null,
      codigoFornecedor: "",
      unidade: "",
      quantidade: 0,
      precoUnitario: 0.0,
      ipi: 0.0,
    },
  ]);

  useEffect(() => {
    if (itensProps.length > 0) {
      setItens(itensProps);
    }
  }, [itensProps]);

  const adicionarItem = () => {
    setItens((prevItens) => [
      ...prevItens,
      {
        id: prevItens.length + 1,
        produto: null,
        codigoFornecedor: "",
        unidade: "",
        quantidade: 0,
        precoUnitario: 0.0,
        ipi: 0.0,
      },
    ]);
  };

  const atualizarItem = (id, campo, valor) => {
    const novosItens = itens.map((item) => {
      if (item.id === id) {
        // Se o campo é produto e foi selecionado um produto do mock
        if (campo === "produto" && valor) {
          const produtoSelecionado = produtosMock.find(
            (p) => p.id === valor.id || p.nome === valor.nome
          );
          if (produtoSelecionado) {
            return {
              ...item,
              produto: produtoSelecionado,
              codigoFornecedor: produtoSelecionado.codigo,
              unidade: produtoSelecionado.unidade,
              precoUnitario: produtoSelecionado.preco,
              quantidade: 1, // valor padrão
            };
          }
        }

        // Para outros campos
        return { ...item, [campo]: valor };
      }
      return item;
    });

    setItens(novosItens);
    onValoresAtualizados(novosItens);
  };

  const excluirItem = (id) => {
    const novosItens = itens.filter((item) => item.id !== id);

    // Se ficou sem itens, adicionar um item vazio
    if (novosItens.length === 0) {
      novosItens.push({
        id: 1,
        produto: null,
        codigoFornecedor: "",
        unidade: "",
        quantidade: 0,
        precoUnitario: 0.0,
        ipi: 0.0,
      });
    }

    setItens(novosItens);
    onValoresAtualizados(novosItens);
  };

  // Cálculo de total para exibição
  const valorTotalItens = itens.reduce((total, item) => {
    const quantidade = parseFloat(item.quantidade) || 0;
    const precoUnitario = parseFloat(item.precoUnitario) || 0;
    const ipi = parseFloat(item.ipi) || 0;

    // Valor do item com IPI incluído
    const valorItemComIpi = quantidade * precoUnitario * (1 + ipi / 100);

    return total + valorItemComIpi;
  }, 0);

  const temProdutoSelecionado = itens.some((item) => item.produto !== null);

  return (
    <Grid item xs={12}>
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
            Itens do pedido de compra
          </Typography>
          <Box>
            <Typography variant="subtitle2" sx={{ textAlign: "right" }}>
              Total do pedido:
              <span style={{ fontWeight: "bold", marginLeft: 8 }}>
                {valorTotalItens.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </span>
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Com impostos incluídos
            </Typography>
          </Box>
        </Box>

        <Paper
          sx={{
            overflow: "hidden",
            borderRadius: 2,
            mb: 3,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <CabecalhoTabela />
          <LinhasTabela
            itens={itens}
            atualizarItem={atualizarItem}
            excluirItem={excluirItem}
            produtosMock={produtosMock}
          />
        </Paper>

        {!temProdutoSelecionado && (
          <Alert severity="info" sx={{ mb: 2 }}>
            Selecione pelo menos um produto para incluir no pedido
          </Alert>
        )}

        <Box display="flex" justifyContent="flex-end">
          <Tooltip title="Adicionar um novo item ao pedido">
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddCircleOutlineIcon />}
              onClick={adicionarItem}
              sx={{
                px: 3,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                },
              }}
            >
              Adicionar Item
            </Button>
          </Tooltip>
        </Box>
      </Box>
    </Grid>
  );
};

export default TabelaPedido;
